import React, { useState } from 'react';
import { getClassIcon, getRoleIcon, getXPBadge } from './wrestlerIcons';
import { getWrestlerName, getWrestlerNameUpper } from './wrestlerUtils';
import placeholder from '../assets/placeholder.png';
import background from '../assets/Background_Test.jpg';

import gmAdamPearce from '../assets/gm/94400_ADAM_PEARCE.png';
import gmNickAldis from '../assets/gm/121300_NICK_ALDIS.png';
import gmShawnMichaels from '../assets/gm/45750_SHAWN_MICHAELS.png';
import gmAva from '../assets/gm/121400_AVA.png';
import gmStephanie from '../assets/gm/14700_STEPHANIE_MCMAHON.png';
import gmPaulHeyman from '../assets/gm/37410_PAUL_HEYMAN_14.png';
import gmWilliamRegal from '../assets/gm/94010_WILLIAM_REGAL.png';
import gmMickFoley from '../assets/gm/14400_MICK_FOLEY.png';
import gmTeddyLong from '../assets/gm/28600_TEDDY_LONG.png';
import gmEricBischoff from '../assets/gm/93900_ERIC_BISCHOFF.png';
import gmSherri from '../assets/gm/42850_SENSATIONAL_SHERRI.png';
import gmMissElizabeth from '../assets/gm/23450_MISS_ELIZABETH.png';
import gmMrFuji from '../assets/gm/130250_MR_FUJI.png';
import gmBobbyHeenan from '../assets/gm/24900_BOBBY_HENNAN.png';
import gmCMPunk from '../assets/gm/31250_CM_PUNK.png';
import gmXavierWoods from '../assets/gm/42030_XAVIER_WOODS.png';
import gmTylerBreeze from '../assets/gm/58110_TYLER_BREEZE.png';
import gmStacyKeibler from '../assets/gm/148600_STACY_KEIBLER_GM.png';
import gmAnonymousGM from '../assets/gm/149100_ANONYMOUS_GM.png';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

const GM_RENDERS = {
  'Adam Pearce': gmAdamPearce, 'Nick Aldis': gmNickAldis, 'Shawn Michaels': gmShawnMichaels,
  'Ava': gmAva, 'Stephanie McMahon': gmStephanie, 'Paul Heyman': gmPaulHeyman,
  'William Regal': gmWilliamRegal, 'Mick Foley': gmMickFoley, 'Teddy Long': gmTeddyLong,
  'Eric Bischoff': gmEricBischoff, 'Sensational Sherri': gmSherri, 'Miss Elizabeth': gmMissElizabeth,
  'Mr Fuji': gmMrFuji, 'Bobby Heenan': gmBobbyHeenan, 'CM Punk': gmCMPunk,
  'Xavier Woods': gmXavierWoods, 'Tyler Breeze': gmTylerBreeze, 'Stacy Keibler': gmStacyKeibler, 'Anonymous GM': gmAnonymousGM,
};

const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };
const STATUS_COLORS = { 'active': '#2ecc71', 'contract': '#3498db', 'local': '#f39c12', 'inactive': '#888' };
const CLASS_COLORS = { 'Fighter': '#3498db', 'Bruiser': '#e74c3c', 'Cruiser': '#2ecc71', 'Specialist': '#9b59b6', 'Giant': '#e67e22' };
const FILTERS = ['ALL', 'ACTIVE', 'INACTIVE', 'LOCAL', 'CONTRACT'];

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .filter-btn:hover { background: rgba(255,255,255,0.1) !important; color: #fff !important; }
  .filter-btn.active-filter { background: rgba(255,255,255,0.1) !important; color: #fff !important; border-color: rgba(255,255,255,0.6) !important; }
  .card-hover:hover { transform: translateY(-3px); outline: 1.5px solid rgba(255,255,255,0.4) !important; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.7) !important; color: #fff !important; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
`;

const S = {
  panel: { background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '12px', boxShadow: '0 20px 80px rgba(0,0,0,0.9)' },
  title: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff', textShadow: '0 0 28px rgba(180,0,0,0.5)' },
  btn: { fontFamily: "'Monda', sans-serif", letterSpacing: '1.5px', fontSize: '0.62rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.35)', color: 'rgba(255,255,255,0.8)', padding: '9px 28px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.18s, border-color 0.18s, color 0.18s' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
};

// ── Reusable wrestler card ──────────────────────────────────────────
const WrestlerCard = ({ w, brandColor }) => (
  <div style={{ background: 'rgba(8,8,8,0.88)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '290px' }}>
    <div style={{ height: '220px', overflow: 'hidden', position: 'relative', background: 'radial-gradient(ellipse at bottom, ' + brandColor + '22 0%, transparent 70%)' }}>
      <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt={getWrestlerName(w, 'formal')}
        style={{ position: 'absolute', bottom: '-15%', left: '50%', transform: 'translateX(-50%)', height: '280px', width: 'auto', objectFit: 'contain', objectPosition: 'bottom' }} />
    </div>
    <div style={{ padding: '8px 10px 10px', borderTop: '1px solid ' + brandColor + '33' }}>
      <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.6rem', letterSpacing: '1px', color: '#fff', marginBottom: '5px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getWrestlerNameUpper(w, 'formal')}</div>
      <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', alignItems: 'center' }}>
        <img loading="lazy" src={getClassIcon(w.fight_class)} alt={w.fight_class} title={w.fight_class} style={{ width: '18px', height: '18px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
        {w.fight_class_secondary && <img loading="lazy" src={getClassIcon(w.fight_class_secondary)} alt={w.fight_class_secondary} style={{ width: '18px', height: '18px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />}
        <img loading="lazy" src={getRoleIcon(w.heel)} alt={w.heel ? 'Heel' : 'Face'} style={{ width: '18px', height: '18px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
        <div style={{ position: 'relative', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <img loading="lazy" src={getXPBadge(w.starting_xp || 0)} alt="XP" style={{ width: '100%', height: '100%', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
          <span style={{ position: 'absolute', fontFamily: "'Anton',sans-serif", fontSize: '6px', color: '#fff', textShadow: '0 1px 2px rgba(0,0,0,0.9)', pointerEvents: 'none' }}>{w.starting_xp || 0}</span>
        </div>
      </div>
    </div>
  </div>
);

// ── Page backgrounds ────────────────────────────────────────────────
const PageBg = ({ brandBg }) => (
  <>
    <img loading="lazy" src={background} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
    {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.2, zIndex: 1 }} />}
    <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.85) 100%)', zIndex: 2 }} />
  </>
);

// ── Main component ──────────────────────────────────────────────────
export default function RosterReview({ roster, brand, gm, isFinal, customLogo, customBg, customColor, customGMs, onBack, onConfirm }) {
  const [activeFilter, setActiveFilter] = useState('ALL');
  const [sortBy, setSortBy] = useState('A-Z');

  const brandColor = customColor || BRAND_COLORS[brand] || '#d4af37';
  const brandLogo = customLogo || BRAND_LOGOS[brand];
  const brandBg = customBg || BRAND_BGS[brand];

  const counts = {
    all: roster.length,
    active: roster.filter(w => w.status === 'active').length,
    inactive: roster.filter(w => w.status === 'inactive').length,
    local: roster.filter(w => w.status === 'local').length,
    contract: roster.filter(w => w.status === 'contract').length,
  };

  // ── ROSTER REVIEW (before draft) ───────────────────────────────────
  if (!isFinal) {
    const filtered = activeFilter === 'ALL' ? roster : roster.filter(w => w.status === activeFilter.toLowerCase());
    const displayed = [...filtered].sort((a, b) => {
      if (sortBy === 'A-Z') return getWrestlerName(a, 'display').localeCompare(getWrestlerName(b, 'display'));
      if (sortBy === 'Z-A') return getWrestlerName(b, 'display').localeCompare(getWrestlerName(a, 'display'));
      if (sortBy === 'CLASS') return (a.fight_class || '').localeCompare(b.fight_class || '');
      if (sortBy === 'ROLE') return (a.heel === b.heel) ? 0 : a.heel ? 1 : -1;
      if (sortBy === 'STATUS') return (a.status || '').localeCompare(b.status || '');
      return 0;
    });
    return (
      <div style={{ position: 'fixed', inset: 0, zIndex: 600 }}>
        <style>{css}</style>
        <PageBg brandBg={brandBg} />
        <div style={{ position: 'absolute', inset: 0, zIndex: 6, display: 'flex', flexDirection: 'column', padding: '70px 24px 16px', gap: '14px', overflow: 'hidden' }}>
          {/* Title */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
            {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '48px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
            <div style={{ ...S.title, fontSize: '1.4rem' }}>ROSTER REVIEW</div>
          </div>
          {/* Filters */}
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
            {FILTERS.map(f => {
              const isActive = activeFilter === f;
              return (
                <button key={f} className={`filter-btn${isActive ? ' active-filter' : ''}`}
                  onClick={() => setActiveFilter(f)}
                  style={{ ...S.mono, fontSize: '0.55rem', letterSpacing: '1.5px', background: 'transparent', border: `1px solid ${isActive ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.2)'}`, color: isActive ? '#fff' : 'rgba(255,255,255,0.4)', padding: '6px 16px', borderRadius: '4px', cursor: 'pointer', transition: 'background 0.15s, border-color 0.15s, color 0.15s', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {f} <span style={{ color: isActive ? STATUS_COLORS[f.toLowerCase()] || '#d4af37' : 'rgba(255,255,255,0.3)', fontSize: '0.5rem' }}>{counts[f.toLowerCase()]}</span>
                </button>
              );
            })}
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '6px' }}>
              {['A-Z', 'Z-A', 'CLASS', 'ROLE', 'STATUS'].map(s => (
                <button key={s} onClick={() => setSortBy(s)}
                  style={{ ...S.mono, fontSize: '0.46rem', letterSpacing: '1px', background: 'transparent', border: '1px solid ' + (sortBy === s ? 'rgba(212,175,55,0.6)' : 'rgba(255,255,255,0.15)'), color: sortBy === s ? '#d4af37' : 'rgba(255,255,255,0.3)', padding: '4px 10px', borderRadius: '3px', cursor: 'pointer' }}>
                  {s}
                </button>
              ))}
              <span style={{ ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.3)', marginLeft: '8px' }}>{displayed.length}</span>
            </div>
          </div>
          {/* Grid */}
          <div style={{ ...S.panel, flex: 1, overflow: 'hidden', padding: '16px' }}>
            <div style={{ height: '100%', overflowY: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '16px', alignContent: 'flex-start' }}>
              {displayed.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '60px', ...S.mono, fontSize: '0.6rem', color: 'rgba(255,255,255,0.2)' }}>Aucune superstar.</div>}
              {displayed.map((w, i) => <WrestlerCard key={`${w.wrestler_id}-${i}`} w={w} brandColor={brandColor} />)}
            </div>
          </div>
          {/* Footer */}
          <div style={{ display: 'flex', gap: '14px', flexShrink: 0, alignItems: 'stretch' }}>
            <div style={{ ...S.panel, flex: 1, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
              <div style={{ ...S.anton, fontSize: '0.8rem', letterSpacing: '2px', color: '#fff' }}>ROSTER INFOS</div>
              {[{ label: 'ALL', value: counts.all, color: '#fff' }, { label: 'ACTIVE', value: counts.active, color: STATUS_COLORS.active }, { label: 'CONTRACT', value: counts.contract, color: STATUS_COLORS.contract }, { label: 'LOCAL', value: counts.local, color: STATUS_COLORS.local }, { label: 'INACTIVE', value: counts.inactive, color: STATUS_COLORS.inactive }].map(({ label, value, color }) => (
                <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ ...S.mono, fontSize: '0.46rem', color: 'rgba(255,255,255,0.35)', letterSpacing: '1px' }}>{label}</span>
                  <span style={{ ...S.mono, fontSize: '0.52rem', color, fontWeight: 'bold' }}>{value}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <button className="btn-wwe" onClick={onConfirm} style={{ ...S.btn, padding: '12px 40px', fontSize: '0.7rem', letterSpacing: '2px', borderColor: 'rgba(255,255,255,0.55)', color: '#fff' }}>CONFIRM</button>
              <button className="btn-wwe" onClick={onBack} style={{ ...S.btn, padding: '6px 40px', fontSize: '0.48rem', borderColor: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.3)' }}>← BACK</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ── FINAL ROSTER (after draft) ─────────────────────────────────────
  const customGM = (customGMs || []).find(g => g.name === gm);
  const gmRender = GM_RENDERS[gm] || (customGM && (customGM.img || customGM.render)) || null;
  const maleCount = roster.filter(w => w.gender === 'M').length;
  const femaleCount = roster.filter(w => w.gender === 'F').length;
  const heelCount = roster.filter(w => w.heel).length;
  const faceCount = roster.filter(w => !w.heel).length;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 600 }}>
      <style>{css}</style>
      <PageBg brandBg={brandBg} />
      <div style={{ position: 'absolute', inset: 0, zIndex: 6, display: 'flex', flexDirection: 'column', padding: '70px 24px 16px', gap: '14px', overflow: 'hidden' }}>

        {/* Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
          {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '48px', objectFit: 'contain', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.9))' }} />}
          <div style={{ ...S.title, fontSize: '1.4rem' }}>FINAL ROSTER</div>
          <div style={{ marginLeft: 'auto', ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '1px' }}>{roster.length} superstars</div>
        </div>

        {/* Main — GM left + grid right */}
        <div style={{ flex: 1, display: 'flex', gap: '16px', overflow: 'hidden', minHeight: 0 }}>

          {/* GM Panel */}
          <div style={{ width: '220px', maxHeight: '420px', flexShrink: 0, borderRadius: '10px', overflow: 'hidden', border: `2px solid ${brandColor}55`, position: 'relative', display: 'flex', flexDirection: 'column', alignSelf: 'flex-start' }}>
            {/* Blurred bg behind GM */}
            {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(5px) brightness(0.35)', zIndex: 0 }} />}
            <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}44 0%, transparent 60%)`, zIndex: 1 }} />

            {/* GM render — bigger, overflows top */}
            <div style={{ position: 'relative', zIndex: 2, flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflow: 'visible', marginTop: '-20px' }}>
              <img loading="lazy" src={gmRender || placeholder} alt={gm || 'GM'}
                style={{ width: '140%', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 6px 24px rgba(0,0,0,0.95))', position: 'relative', zIndex: 3 }} />
            </div>

            {/* GM name */}
            <div style={{ position: 'relative', zIndex: 4, padding: '8px 12px 0', background: 'rgba(0,0,0,0.75)', textAlign: 'center' }}>
              <div style={{ ...S.anton, fontSize: '0.72rem', letterSpacing: '2px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{gm ? gm.toUpperCase() : ''}</div>
              <div style={{ ...S.mono, fontSize: '0.42rem', color: brandColor, letterSpacing: '1.5px', marginBottom: '8px', marginTop: '2px' }}>GENERAL MANAGER</div>
            </div>

            {/* Brand section — non blurred bg + logo */}
            <div style={{ position: 'relative', zIndex: 4, overflow: 'hidden', height: '70px', flexShrink: 0 }}>
              {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />}
              <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1 }} />
              <div style={{ position: 'relative', zIndex: 2, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {brandLogo
                  ? <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '48px', objectFit: 'contain', filter: 'drop-shadow(0 2px 12px rgba(0,0,0,0.9))' }} />
                  : <div style={{ ...S.title, fontSize: '1rem', color: brandColor }}>{brand}</div>
                }
              </div>
            </div>
          </div>

          {/* Cards grid */}
          <div style={{ ...S.panel, flex: 1, overflow: 'hidden', padding: '14px' }}>
            <div style={{ height: '100%', overflowY: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '16px', alignContent: 'flex-start' }}>
              {roster.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: '60px', ...S.mono, fontSize: '0.6rem', color: 'rgba(255,255,255,0.2)' }}>Aucune superstar draftée.</div>}
              {roster.map((w, i) => <WrestlerCard key={`${w.wrestler_id}-${i}`} w={w} brandColor={brandColor} />)}
            </div>
          </div>
        </div>

        {/* Roster infos + buttons */}
        <div style={{ display: 'flex', gap: '14px', flexShrink: 0, alignItems: 'stretch' }}>
          <div style={{ ...S.panel, flex: 1, padding: '14px 20px', display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
            <div style={{ ...S.anton, fontSize: '0.8rem', letterSpacing: '2px', color: '#fff', flexShrink: 0 }}>ROSTER INFOS</div>

            {/* Genre */}
            <div>
              <div style={{ ...S.mono, fontSize: '0.44rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.3)', marginBottom: '3px' }}>GENRE</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <span style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.6)' }}>Male : <span style={{ color: '#fff' }}>{maleCount}</span></span>
                <span style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.6)' }}>Female : <span style={{ color: '#fff' }}>{femaleCount}</span></span>
              </div>
            </div>

            <div style={{ width: '1px', height: '32px', background: 'rgba(255,255,255,0.08)', flexShrink: 0 }} />

            {/* Class */}
            <div>
              <div style={{ ...S.mono, fontSize: '0.44rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.3)', marginBottom: '3px' }}>CLASS</div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {[{ key: 'Specialist', color: '#9b59b6' }, { key: 'Fighter', color: '#3498db' }, { key: 'Bruiser', color: '#e74c3c' }, { key: 'Cruiser', color: '#2ecc71' }, { key: 'Giant', color: '#e67e22' }].map(({ key, color }) => {
                  const count = roster.filter(w => w.fight_class === key).length;
                  return count > 0 ? (
                    <span key={key} style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.6)' }}>{key} : <span style={{ color }}>{count}</span></span>
                  ) : null;
                })}
              </div>
            </div>

            <div style={{ width: '1px', height: '32px', background: 'rgba(255,255,255,0.08)', flexShrink: 0 }} />

            {/* Role */}
            <div>
              <div style={{ ...S.mono, fontSize: '0.44rem', letterSpacing: '1px', color: 'rgba(255,255,255,0.3)', marginBottom: '3px' }}>ROLE</div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <span style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.6)' }}>Heel : <span style={{ color: '#e74c3c' }}>{heelCount}</span></span>
                <span style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.6)' }}>Face : <span style={{ color: '#2ecc71' }}>{faceCount}</span></span>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button className="btn-wwe" onClick={onConfirm}
              style={{ ...S.btn, padding: '12px 40px', fontSize: '0.7rem', letterSpacing: '2px', borderColor: 'rgba(255,255,255,0.55)', color: '#fff' }}>
              START SEASON ▶
            </button>
            <button className="btn-wwe" onClick={onBack}
              style={{ ...S.btn, padding: '6px 40px', fontSize: '0.48rem', borderColor: 'rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.3)' }}>
              ← BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
